<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qDV2nz/tc-custom/9781504021579.jpg?1729379716501" alt="This image is the cover for the book Relentless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Relentless
      </h1>
      <p class="bookDescription body article font2">
        <b>Passion ignites for an outlaw and his captive in this western romance by the </b><b><i>USA Today</i></b><b>–bestselling author who “keeps getting better with every outing” (</b><b><i>Publishers Weekly </i></b><b>on </b><b><i>Beloved Warrior</i></b><b>).</b><br/><br/> Once a decorated army officer, Rafe Tyler was convicted as a thief and a traitor, and spent 10 years in prison. Now he’s ready to exact his long-awaited revenge. His thirst for blood takes him to Colorado to destroy the man who framed him.<br/>  <br/> Sheltered Boston beauty Shea Randall arrives in the rough-and-ready western town to reunite with the father she believed long dead. Instead, she is abducted by a darkly handsome outlaw. Her only hope for survival is to escape the mountain lair she is forced to share with her captor. But Shea is reluctantly drawn to the desperado whose fiery passions inspire her own—and whose forbidden desire for her sets him on a rocky road to redemption and hard-won love.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Potter
      </h2>
      
      <p class="authorDescription body article">Patricia Potter is a <I>USA Today</I>&ndash;bestselling author of more than fifty romantic novels. A seven-time RITA Award finalist and three-time Maggie Award winner, she was named Storyteller of the Year by <I>Romantic Times</I> and received the magazine&rsquo;s Career Achievement Award for Western Romance. Potter is a past board member and president of Romance Writers of America. Prior to becoming a fiction author, she was a reporter for the <I>Atlanta Journal </I>and the president of a public relations firm in Atlanta. She lives in Memphis, Tennessee.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?acb7c690